import * as ActionType from '../../constants/actionType';
import {ViewMode} from '../../constants/dataEnum';

const initialState = {
  prevViewMode: ViewMode.LOGIN,
  viewMode: ViewMode.LOGIN,
  isManualReteachPage: false,
  snackbar: {
    show: false,
    text: null,
    style: '',
    timeout: 0,
    useActionButton: false,
    actionButton: () => {},
    disableBlur: true,
    title: null,
  },
  loading: {
    show: false,
    text: '',
    onCancel: () => {},
  },
  showDrawer: false,
  triggerRebuildConnection: null,
  headChannelsConfigOpen: false,
  isAnyModalShow: false,
  isOverrideBeforeUnload: false,
  isRestoringSoftware: false,
};

export default function appStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.CHANGE_VIEW:
      return {...state, viewMode: action.view, prevViewMode: action.prevView};
    case ActionType.OVERRIDE_BEFORE_UNLOAD:
      return {...state, isOverrideBeforeUnload: action.isOverride};
    case ActionType.SHOW_SNACKBAR:
      return {...state, snackbar: action.snackbar};
    case ActionType.SHOW_LOADING:
      return {...state, loading: action.loading};
    case ActionType.UPDATE_LOADING:
      return {...state, loading: {...action.loading}};
    case ActionType.HIDE_LOADING:
      return {...state, loading: {show: false, text: '', onCancel: () => {}}};
    case ActionType.SET_DRAWER_VISIBILITY:
      return {...state, showDrawer: action.data};
    case ActionType.TRIGGER_REBUILD_CONNECTION:
      return {...state, triggerRebuildConnection: action.data};
    case ActionType.SET_HEAD_CHANNELS_CONFIG_OPEN:
      return {...state, headChannelsConfigOpen: action.data};
    case ActionType.SET_IS_ANY_MODAL_SHOW:
      return {...state, isAnyModalShow: action.isShow};
    case ActionType.SET_IS_MANUAL_RETEACH_PAGE:
      return {...state, isManualReteachPage: true};
    case ActionType.RESET_IS_MANUAL_RETEACH_PAGE:
      return {...state, isManualReteachPage: false};
    case ActionType.SET_IS_RESTORING_SOFTWARE:
      return {...state, isRestoringSoftware: action.isRestoring};
    case ActionType.RESTORE_APPSTATE:
      return action.state;
    default:
      return state;
  }
}
